// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AttributeValueAttributeList_wrapper__1JHm0","alert":"AttributeValueAttributeList_alert__2vhsi","searchInput":"AttributeValueAttributeList_searchInput__2N8D-"};